<template>
  <div class="cart-empty">
    <div class="container">
      <div class="cart-empty__inner">
        <div class="cart-empty__icon">
          <icon name="shopping-basket" />
        </div>
        <span class="cart-empty__title">{{ $t("services.cart.empty") }}</span>
        <div class="cart-empty__actions">
          <router-link
            v-if="isOrderingAvailable"
            :to="{ name: 'categories', params: { id: $route.params.id } }"
            class="primary-button"
          >
            {{ $t("services.cart.goToCatalog") }}
          </router-link>
          <router-link
            :to="{ name: 'participant', params: { id: $route.params.id } }"
            class="primary-button primary-button--white"
          >
            {{ $t("services.cart.goToMainPage") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import diffInSeconds from "@/helpers/diffInSeconds";

export default {
  name: "CartEmpty",
  computed: {
    ...mapState("event", ["event"]),

    isOrderingAvailable() {
      return this.event.exhibition.is_allowed_create_additional_order;
    }
  },
  methods: {
    diffInSeconds
  }
};
</script>

<style lang="scss">
.cart-empty {
  padding: 50px 0;
  @media (max-width: 540px) {
    padding: 30px 0;
  }

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__icon {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: var(--white, #fff);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;

    svg {
      width: 60px;
      height: 60px;
    }
  }

  &__title {
    font-feature-settings: "clig" off, "liga" off;
    font-size: 1.75rem;
    font-weight: 500;
    line-height: 34px;
    margin-bottom: 30px;
  }

  &__actions {
    display: flex;
    @media (max-width: 440px) {
      flex-direction: column;
      width: 100%;
    }

    a:not(:last-child) {
      margin-right: 30px;
      @media (max-width: 440px) {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }
  }
}
</style>
